import styled from 'styled-components';
import { maxBodyWidth, largeLayout, topbarHeight } from '@styles/layout';
import { Link } from '@components/Link/Link';

export const TopbarWrapper = styled.header`
  position: fixed;
  height: ${topbarHeight}px;
  max-width: ${maxBodyWidth}px;
  top: 0;
  left: auto;
  right: auto;
  width: 100%;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2000;
`;

export const TopbarContent = styled.div`
  max-width: ${largeLayout.getSize()}px;
  margin: 0 auto;
  height: ${topbarHeight}px;
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
`;

export const LogoContainer = styled(Link)`
  margin-right: auto; 
`;



// WEBPACK FOOTER //
// src/app/src/components/Topbar/Topbar.s.ts